import React, { useRef, useState } from "react";
import "./adCard.css";
import axios from "axios";
import { Image, Placeholder, Transformation } from "cloudinary-react";
import { backend } from "../../../backend";
import { createSEOUrl } from "../../../utils/createSEOUrl";
import { logAxiosError } from "../../../logging/error";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import facilitiesData from "../../../assets/facilities.json";
import CloseButtonV2 from "../../../components/PasswordRulesModal/CloseButtonV2";

export default function AdCard({ id, props, onClose }) {
  const hasImages =
    id.images && id.images.length > 0 && Object.values(id.images[0])[0];
  // image loading state
  const [imageLoading, setImageLoading] = useState(hasImages);

  const handleImageLoad = () => {
    setImageLoading(false);
  };

  const handleAdClick = async () => {
    try {
      await axios.post(backend("/api/listings/click"), {
        id: id._id,
      });
    } catch (error) {
      logAxiosError(error);
    }
  };

  const NextArrow = ({ onClick }) => (
    <button
      aria-label="Bläddra till nästa referens"
      className="custom-arrow next"
      onClick={onClick}
    >
      <svg
        fill="currentColor"
        viewBox="0 0 16 16"
        height="1em"
        width="1em"
        className="review-arrow"
      >
        <path
          fillRule="evenodd"
          d="M4.646 1.646a.5.5 0 01.708 0l6 6a.5.5 0 010 .708l-6 6a.5.5 0 01-.708-.708L10.293 8 4.646 2.354a.5.5 0 010-.708z"
        />
      </svg>
    </button>
  );

  const PrevArrow = ({ onClick }) => (
    <button
      aria-label="Bläddra till föregående referens"
      className="custom-arrow prev"
      onClick={onClick}
    >
      <svg
        fill="currentColor"
        viewBox="0 0 16 16"
        height="1em"
        width="1em"
        className="review-arrow "
      >
        <path
          fillRule="evenodd"
          d="M11.354 1.646a.5.5 0 010 .708L5.707 8l5.647 5.646a.5.5 0 01-.708.708l-6-6a.5.5 0 010-.708l6-6a.5.5 0 01.708 0z"
        />
      </svg>
    </button>
  );

  const sliderRef = useRef(null);

  const settings = {
    speed: 500,
    infinite: id.images && id.images.length > 1,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: id.images && id.images.length > 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  const noImage = () => {
    return (
      <svg
        className="slash-eye-icon"
        fill="currentColor"
        viewBox="0 0 16 16"
        {...props}
      >
        <path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 00-2.79.588l.77.771A5.944 5.944 0 018 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0114.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755-.165.165-.337.328-.517.486l.708.709z" />
        <path d="M11.297 9.176a3.5 3.5 0 00-4.474-4.474l.823.823a2.5 2.5 0 012.829 2.829l.822.822zm-2.943 1.299l.822.822a3.5 3.5 0 01-4.474-4.474l.823.823a2.5 2.5 0 002.829 2.829z" />
        <path d="M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 001.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 018 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884l-12-12 .708-.708 12 12-.708.708z" />
      </svg>
    );
  };
  const locationIcon = (
    <svg width="1.7rem" height="1.7rem" viewBox="0 0 24 24" fill="#4e8157">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0036 14.0035C14.4889 14.0035 16.5036 11.9887 16.5036 9.50347C16.5036 7.01819 14.4889 5.00347 12.0036 5.00347C9.51831 5.00347 7.50359 7.01819 7.50359 9.50347C7.50359 11.9887 9.51831 14.0035 12.0036 14.0035ZM12.0036 12.0071C10.6209 12.0071 9.5 10.8862 9.5 9.50347C9.5 8.12077 10.6209 6.99988 12.0036 6.99988C13.3863 6.99988 14.5072 8.12077 14.5072 9.50347C14.5072 10.8862 13.3863 12.0071 12.0036 12.0071Z"
        fill="#4e8157"
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.272 11.5818C22.5649 5.78816 18.0052 0.00354004 12 0.00354004C5.99649 0.00354004 1.43639 5.7961 2.72816 11.5825C3.72523 16.2821 7.7572 20.8465 10.1636 23.2269C11.1942 24.2463 12.8058 24.2463 13.8364 23.2269C16.2429 20.8464 20.2752 16.2816 21.272 11.5818ZM12 2.00354C16.7124 2.00354 20.3368 6.58981 19.32 11.1462C18.8316 13.3355 17.7359 15.3015 16.4501 17.119C15.1064 19.0184 13.5829 20.6644 12.4299 21.805C12.1786 22.0536 11.8214 22.0536 11.5701 21.805C10.4171 20.6645 8.89379 19.0186 7.55009 17.1193C6.26419 15.3017 5.16886 13.3361 4.68011 11.1467C3.66438 6.59682 7.29012 2.00354 12 2.00354Z"
        fill="#4e8157"
      ></path>
    </svg>
  );
  const areaIcon = (
    <svg
      // fill="#4e8157"
      width="2rem"
      height="2rem"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <path
          stroke="#4e8157"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.6"
          d="M8 20H4m0 0v-4m0 4 6-6m6-10h4m0 0v4m0-4-6 6"
        ></path>
      </g>
    </svg>
  );
  const peopleIcon = (
    <svg
      fill="#4e8157"
      width="2rem"
      height="2rem"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      stroke="#4e8157"
      strokeWidth="0.4"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke="#CCCCCC"
        strokeWidth="0"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <path
          fillRule="evenodd"
          d="M3.5 8a5.5 5.5 0 118.596 4.547 9.005 9.005 0 015.9 8.18.75.75 0 01-1.5.045 7.5 7.5 0 00-14.993 0 .75.75 0 01-1.499-.044 9.005 9.005 0 015.9-8.181A5.494 5.494 0 013.5 8zM9 4a4 4 0 100 8 4 4 0 000-8z"
        ></path>
        <path d="M17.29 8c-.148 0-.292.01-.434.03a.75.75 0 11-.212-1.484 4.53 4.53 0 013.38 8.097 6.69 6.69 0 013.956 6.107.75.75 0 01-1.5 0 5.193 5.193 0 00-3.696-4.972l-.534-.16v-1.676l.41-.209A3.03 3.03 0 0017.29 8z"></path>
      </g>
    </svg>
  );

  const facilitiesLimit = 2;
  const facilities = id.facilities || [];
  const remainingFacilities = facilities.length - facilitiesLimit;

  const prices = [
    { value: id.hourly_rent, label: "tim" },
    { value: id.daily_rent, label: "dag" },
    { value: id.monthly_rent, label: "mån" },
    { value: id.workspace_rent, label: "plats" },
  ].filter((p) => p.value && p.value !== 0);

  prices.sort((a, b) => a.value - b.value);

  const mainPrice = prices[0];
  const otherPrices = prices.slice(1);

  let primary =
    id.district?.replace(/-/g, " ") ||
    id.zone?.replace(/-/g, " ") ||
    id.postCode_district;

  let primaryTwo;
  if (
    primary === "Askim Frölunda Högsbo" ||
    primary === "Örgryte Härlanda" ||
    primary === "Majorna Linné"
  ) {
    primaryTwo = primary.replace(/ /g, "-");
  }

  const isSame =
    primary &&
    id.municipality &&
    primary.toLowerCase() === id.municipality.toLowerCase();

  const secondary = isSame ? id.county : id.municipality;

  return (
    <a
      onClick={handleAdClick}
      className="ad-card-outer-link"
      href={`/lediga-lokaler/${createSEOUrl(id.municipality)}/${createSEOUrl(
        id.type_of_room,
      )}/${createSEOUrl(id.address)}/${id._id}`}
      aria-label={`Annons för ${id.type_of_room}, ${id.area} kvadratmeter, på ${id.address} i ${id.municipality}`}
    >
      <article className={`search-result-card`}>
        <div className="ad-card-top">
          <div className="ad-card-type">
            <span>{id.type_of_room}</span>
          </div>
          {onClose && <CloseButtonV2 onClick={onClose} />}
        </div>
        {hasImages ? (
          <div>
            {/* skeleton overlay while image is loading */}
            {imageLoading && (
              <div
                className="skeleton-image"
                style={{
                  margin: "0 auto",
                  width: "100%",
                }}
              ></div>
            )}

            {/* render slider/images */}
            <div className="slider-wrapper">
              <Slider ref={sliderRef} {...settings}>
                {id.images.slice(0, 4).map((image, i) => (
                  <div key={i}>
                    <Image
                      alt={
                        id.type_of_room +
                        " finns att hyra på " +
                        id.address +
                        " i " +
                        id.municipality
                      }
                      fetchFormat="webp"
                      quality="auto:best"
                      loading="lazy"
                      responsiveUseBreakpoints="true"
                      cloudName="vakansa"
                      publicId={`listings/${id._id}/${image}`}
                      crop="fill"
                      width="350"
                      height="250"
                      style={{
                        margin: "0 auto",
                        width: "100%",
                        opacity: imageLoading ? 0 : 1,
                        transition: "opacity 0.3s ease",
                      }}
                      className="adcard-image"
                      onLoad={i === 0 ? handleImageLoad : undefined}
                      onError={i === 0 ? handleImageLoad : undefined}
                    >
                      <Transformation effect="sharpen" />
                      <Placeholder type="predominant" />
                    </Image>
                  </div>
                ))}
              </Slider>
            </div>
          </div>
        ) : (
          <div className="adcard-no-image">
            {noImage()}
            <span>Bild inte tillgänglig</span>
          </div>
        )}

        <div className="search-ad-card">
          <div className="search-ad-card-heading">
            <h3>
              {id.address.charAt(0).toUpperCase() +
                id.address.slice(1).toLowerCase()}
            </h3>
            <div>
              <p>
                {locationIcon}
                {primaryTwo || primary}
                {secondary ? `, ${secondary}` : ""}
              </p>
            </div>
          </div>
          <div className="search-ad-card-info">
            <p>
              {areaIcon}
              {id.area} m2
            </p>
            {id.workspaces && (
              <p>
                {peopleIcon}
                {id.workspaces} platser
              </p>
            )}
          </div>
          <div className="search-ad-card-facilities">
            {facilities.slice(0, facilitiesLimit).map((facility, index) => (
              <span key={index} className="facility-tag">
                {facilitiesData.facilities[facility]?.value}
              </span>
            ))}

            {remainingFacilities > 0 && (
              <span className="facility-tag-more">+{remainingFacilities}</span>
            )}
          </div>
          <div className="search-ad-card-price">
            {mainPrice && (
              <>
                <span className="main-price">
                  {mainPrice.value} kr/{mainPrice.label}
                </span>
                {otherPrices.map((p, i) => (
                  <span className="other-prices" key={i}>
                    {p.value} kr/{p.label}
                  </span>
                ))}
              </>
            )}
          </div>
        </div>
      </article>
    </a>
  );
}
